function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* global CustomEvent, setTimeout */
import CableReady from 'cable_ready';

var debounceEvents = function debounceEvents(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var timeoutId;
  var events = [];
  return function () {
    clearTimeout(timeoutId);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    events = [].concat(_toConsumableArray(events), args);
    timeoutId = setTimeout(function () {
      timeoutId = null;
      callback(events);
      events = [];
    }, delay);
  };
};

export var createSubscription = function createSubscription(consumer) {
  consumer.subscriptions.create('Futurism::Channel', {
    connected: function connected() {
      var _this = this;

      window.Futurism = this;
      document.addEventListener('futurism:appear', debounceEvents(function (events) {
        _this.send({
          signed_params: events.map(function (e) {
            return e.target.dataset.signedParams;
          }),
          sgids: events.map(function (e) {
            return e.target.dataset.sgid;
          }),
          signed_controllers: events.map(function (e) {
            return e.target.dataset.signedController;
          }),
          urls: events.map(function (_) {
            return window.location.href;
          }),
          broadcast_each: events.map(function (e) {
            return e.target.dataset.broadcastEach;
          })
        });
      }));
    },
    received: function received(data) {
      if (data.cableReady) {
        CableReady.perform(data.operations, {
          emitMissingElementWarnings: false
        });
        document.dispatchEvent(new CustomEvent('futurism:appeared', {
          bubbles: true,
          cancelable: true
        }));
      }
    }
  });
};